import { CustomTheme } from "@orijinworks/frontend-commons";

export const DeleteModalStyles = (theme) => ({
    width: '396px',
    margin: '0px auto',
    '& h6': {
        fontSize: '20px',
        color: theme.palette.navy.main,
    },
    '& .modal-body': {
        color: 'var(--grey-110)',
        padding: '0px 24px 20px',
    },
    '& .modal-footer': {
        justifyContent: 'flex-end !important'
    },
    '& .modal-footer div': {
        flexFlow: 'row-reverse',
        '& button:nth-child(1)': {
            marginLeft: '10px',
        },
    }
});
